import { render, staticRenderFns } from "./NalPromo.vue?vue&type=template&id=5cc64f36"
import script from "./NalPromo.vue?vue&type=script&lang=ts"
export * from "./NalPromo.vue?vue&type=script&lang=ts"
import style0 from "./NalPromo.vue?vue&type=style&index=0&id=5cc64f36&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports